<template>
  <div
    v-if="getShowControlInstructionsModal"
    class="
      position-absolute
      top-50
      start-50
      translate-middle
      more-on-top
      w-100 w-md-75 w-xl-50
    "
  >
    <div class="card shadow-lg text-start">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <h5 class="mb-0">Application Controls</h5>
        <button
          class="btn-close"
          aria-label="Close"
          @click="closeControlInstructionsModal"
        ></button>
      </div>
      <div class="card-body p-5">
        <h2 class="mb-3">Stepping Through the Activity</h2>
        <p>
          Click the button on the side of the step description to progress to
          the next step.
        </p>
        <p>
          The button will show a check mark if you've completed it correctly, or
          an error message if you cannot progress.
        </p>
        <p>Click the checkmarked button to undo and retry a step.</p>
        <h2 class="mb-3">Total Station Controls</h2>
        <ul style="list-style-type: none" class="ps-0">
          <li>
            <span class="badge bg-secondary more-on-top">0</span> zeroes the Hz
            readings
          </li>
          <li>
            <span class="badge bg-secondary more-on-top">Z</span> looks through
            the lens
          </li>
          <li>
            <span class="badge bg-secondary">W</span> and
            <span class="badge bg-secondary">S</span> move the orientation up or
            down, respectively
          </li>
          <li>
            <span class="badge bg-secondary">A</span> and
            <span class="badge bg-secondary">D</span> move the orientation left
            or right, respectively
          </li>
          <li>
            <span class="badge bg-secondary">F</span> triggers the measurement
            against the prism
          </li>
          <li>
            <span class="badge bg-secondary">Shift</span> when held down
            decreases the increments of the total station's movements
          </li>
        </ul>
        <h2 class="mb-3">Prism Holder Controls</h2>
        <ul style="list-style-type: none" class="ps-0">
          <li>
            <span class="badge bg-secondary more-on-top">P</span> makes the
            prism holder place a stake at the prism's location
          </li>
          <li>
            <span class="badge bg-secondary more-on-top">I</span> and
            <span class="badge bg-secondary more-on-top">K</span> make the prism
            holder move the prism further away or closer to the total station,
            respectively
          </li>
          <li>
            <span class="badge bg-secondary">J</span> and
            <span class="badge bg-secondary">L</span> make the prism holder move
            the prism to the left or right, respectively
          </li>
          <li>
            <span class="badge bg-secondary">Shift</span> when held down
            decreases the increments of the prism holder's movements
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ControlInstructionsModal",
  methods: {
    ...mapActions(["closeControlInstructionsModal"])
  },
  computed: {
    ...mapGetters(["getShowControlInstructionsModal"])
  }
};
</script>

<style scoped>
/* Custom Width Breakpoints */

/* MD breakpoint*/
@media (min-width: 768px) {
  .w-md-50 {
    width: 50% !important;
  }
}

/* XL breakpoint */
@media (min-width: 1200px) {
  .w-xl-50 {
    width: 50% !important;
  }
}
</style>
